import { useCallback, useState } from 'react'
import { ApiError, CallApiOptions, useCallApi } from '../../api/Common'
import {
  CourseApi,
  CourseDetailsListResponse,
  LoginResponse,
  MissionApi,
  MissionResponse,
  UserApi,
} from '../../openapi'

export const useDigitaneApi = () => {
  const { callApi, defaultConfiguration } = useCallApi()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<ApiError | null>(null)

  //コースレベルで情報を取得する（一覧画面でのみ使用想定）
  const getAllMissions = useCallback(async () => {
    setIsLoading(true)
    const courseApi = new CourseApi(await defaultConfiguration())
    try {
      const response = await callApi<CourseDetailsListResponse, null>(
        null,
        () =>
          courseApi.apiV1CoursesDetailsGet(
            ['robcratch', 'RBJ'],
            undefined, //siteを絞り込むと相互にリミックスしたミッション情報が取得できないので両方取得
            [],
            false,
          ),
      )
      if (response.error) {
        setError(response.error)
      }
      if (response.success) {
        return response.success.data
      }
    } finally {
      setIsLoading(false)
    }
  }, [callApi, defaultConfiguration])
  //ステージレベルで情報を取得する（エディタ画面で使用想定）
  const getStageInfo = async (
    missionIdStr: string,
    options?: CallApiOptions,
  ) => {
    if (missionIdStr === '') {
      throw new Error('missionId is none')
    }
    const missionId = Number(missionIdStr)
    if (isNaN(Number(missionId))) {
      if (location.hostname === 'localhost') {
        return
      }
      throw new Error('missionId is not a number')
    }
    setIsLoading(true)
    const missionApi = new MissionApi(await defaultConfiguration())
    try {
      const response = await callApi<MissionResponse, null>(
        null,
        () => missionApi.apiV1MissionsGet(missionId, false),
        options,
      )
      if (response.error) {
        setError(response.error)
      }
      if (response.success) {
        return response.success.data
      }
    } finally {
      setIsLoading(false)
    }
  }

  //User情報取得API
  const getUserInfo = async () => {
    setIsLoading(true)
    const userApi = new UserApi(await defaultConfiguration())
    try {
      const response = await callApi<LoginResponse, null>(null, () =>
        userApi.apiV1UserGet(),
      )
      if (response.error) {
        setError(response.error)
      }
      if (response.success) {
        return response.success.data
      }
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    error,
    getStageInfo,
    getAllMissions,
    getUserInfo,
  }
}
